import i18n from '@/services/i18n.service'

class TranslationService {
  translate(key: string): string {
    return i18n.global.t(key)
  }
}

export default new TranslationService()
